import React, { useContext } from "react";
import { Switch, Route } from "react-router-dom";

import { LoanFormContext } from "./LoanForm";
import FormStep from "../../FormStep";
import { SmallCardButton } from "./../Controls";
import PurchaseForm from "./Purchase";

const TypeOfFinance: React.FunctionComponent<{
  onSubmit?: (value: string) => void;
}> = (props: { onSubmit?: (value: string) => void }) => {
  const loanFormContext = useContext(LoanFormContext);

  const handleSubmit = (value: string) => {
    if (props.onSubmit) props.onSubmit(value);
  };

  return (
    <div>
      <FormStep
        header={
          <>
            <h1 className="heading-main display-title">MORTGAGES MADE EASY</h1>
            <h2 className="heading-secondary">
              Find out how much house you can afford!
            </h2>
          </>
        }
      >
        <div className="form-cardBtns-wrapper form-inputs-wrapper">
          <SmallCardButton
            label="Purchase"
            icon={<i className="icon-home-2"></i>}
            onClick={() => {
              handleSubmit("purchase");
            }}
            anim
            active={
              loanFormContext.typeOfFinance?.value === "purchase" ? true : false
            }
          />
          <SmallCardButton
            label="Refinance"
            icon={<i className="icon-nbr-money-bag"></i>}
            onClick={() => {
              handleSubmit("refinance");
            }}
            anim
            active={
              loanFormContext.typeOfFinance?.value === "refinance"
                ? true
                : false
            }
          />
        </div>
      </FormStep>
    </div>
  );
};

export default TypeOfFinance;
